import { NamedTimeZoneImpl, createPlugin } from '@fullcalendar/common';
import { CalendarDateService } from '@uplift/services';


class UpliftNamedTimeZone extends NamedTimeZoneImpl {
  offsetForArray(a: [number, number, number, number, number, number, number]): number {
    return CalendarDateService.date.tz(a, this.timeZoneName).utcOffset();
  }

  timestampToArray(ms: number): number[] {
    return CalendarDateService.date.tz(ms, this.timeZoneName).toArray();
  }
}


export const UpliftTZPlugin = createPlugin({
  namedTimeZonedImpl: UpliftNamedTimeZone,
});
